import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../../redux/store";
import { serializeSession, useSession } from "../../../models/session";
import { showModal, modal } from "../../modal/modalSlice";
import { ToastProps } from "../ToastManager";

export type EncryptionNoticeToastProps = {
  sessionUid: string
  boardUid: string
} & ToastProps

export function EncryptionNoticeToast({ sessionUid, boardUid, dismiss }: EncryptionNoticeToastProps) {
  const { t } = useTranslation();
  const dispatch = useDispatch<AppDispatch>();
  const [session] = useSession(boardUid, sessionUid);

  const handleClick = () => {
    if (session) {
      dispatch(showModal(modal("configureSession", { sessionData: serializeSession(session) })));
    }
    dismiss();
  };

  return (
    <div className="notification is-warning" onClick={handleClick} style={{ cursor: "pointer" }}>
      <span>
        {t("toast.encryption.notice")}
      </span>
    </div>
  );
}
